<template>
  <div class="lesson-container">
      <h3>Lesson One: Introduction</h3>
      <p>Hindi is one of the many national languages in India. Hindi is related to Urdu, which shares nearly identical grammar and a substantial amount of vocabulary.</p>
      <p>However, unlike Urdu, Hindi is written using the Devanagari script.</p>

  </div>
</template>

<script>
export default {
  name: "HindiLessonOne",
  props: {
      currentLanguage: {type: String},
  },
  data() {
    return {
     
    };
  },
  methods: {
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
